import { LoadableAfterPaint } from '@confluence/loadable';

export const DeleteSpacePortal = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DeleteSpacePortal" */ './DeleteSpacePortal.tsx'))
			.DeleteSpacePortal,
	name: 'DeleteSpacePortal',
});
